/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { appPalette, appType, type Palette, type TypePair } from '@sidekick/design-tokens';
import type { WordmarkLead } from './Wordmark.js';

/**
 * The 's' glyph — secondary mark for favicon / app icon / sidebar.
 * Ported from apps/web/design-reference/wordmark.jsx.
 */
export interface SecondGlyphProps {
  lead?: WordmarkLead;
  palette?: Palette;
  type?: TypePair;
  size?: number;
  square?: boolean;
}

export function SecondGlyph({
  lead = 'serif',
  palette = appPalette,
  type = appType,
  size = 64,
  square = true,
}: SecondGlyphProps) {
  const family = lead === 'serif' ? type.serif : type.sans;
  const weight = lead === 'serif' ? 400 : 500;

  return (
    <div
      style={{
        width: size,
        height: size,
        background: square ? palette.fg : 'transparent',
        color: square ? palette.bg : palette.fg,
        borderRadius: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: family,
        fontWeight: weight,
        fontSize: size * 0.72,
        lineHeight: 1,
        letterSpacing: '-0.04em',
        fontFeatureSettings: lead === 'serif' ? type.serifFeat : 'normal',
        paddingBottom: lead === 'serif' ? size * 0.04 : 0,
      }}
    >
      s
    </div>
  );
}
